import { Glyphs } from '@/ui/rapid-ui/glyphs'
import { imgixUrl } from '@/ui/utilities/imgix'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import type { DashboardCampaignModel } from './dashboard.vm'

type CampaignCardImagePlaceholderProps = {
	branding: DashboardCampaignModel['branding']
	alt: string
}

export function CampaignCardImagePlaceholder({ branding, alt }: CampaignCardImagePlaceholderProps) {
	const { t } = useTranslation()
	const [failedLogoUrl, setFailedLogoUrl] = useState<string | null>(null)

	const logoUrl = branding?.logoUrl ? imgixUrl(branding.logoUrl, { w: 240, h: 240, fit: 'max', dpr: 2 }) : null

	if (branding && logoUrl && logoUrl !== failedLogoUrl) {
		return (
			<div
				className="absolute inset-0 flex items-center justify-center p-[20%] overflow-hidden"
				style={{ backgroundColor: branding.background }}
			>
				<div
					className="absolute inset-0 scale-150 blur-2xl opacity-60 bg-cover bg-no-repeat bg-center"
					style={{ backgroundImage: `url(${logoUrl})` }}
				/>
				<img
					className="relative max-w-full max-h-full object-contain"
					src={logoUrl}
					alt={alt}
					onError={() => setFailedLogoUrl(logoUrl)}
				/>
			</div>
		)
	}

	const noImageText = t('dashboard.card.noImage')

	return (
		<div
			role="img"
			aria-label={`${alt}, ${noImageText}`}
			className="absolute inset-0 flex flex-col items-center justify-center gap-2 overflow-hidden bg-grey-100 text-grey-400"
		>
			<div className="absolute -top-1/4 -left-1/4 size-3/4 rounded-full bg-purple-200 blur-3xl" />
			<div className="absolute -bottom-1/4 -right-1/4 size-3/4 rounded-full bg-grey-300 blur-3xl" />
			<span className="relative size-8">
				<Glyphs.core.ImageAddIcon />
			</span>
			<span className="relative text-sm text-grey-500">{noImageText}</span>
		</div>
	)
}
